<template>
  <div class="tw-block tw-w-full tw-mx-auto">
    <div
      class="tw-mt-12 tw-mx-16 tw-bg-white tw-shadow-lg  tw-rounded tw-px-6 tw-pt-6 tw-pb-8 tw-mb-4"
    >
      <div class="tw-w-full tw-mt-4">
        <form class>
          <div class="tw-flex tw-flex-wrap ">
            <div class="tw-w-full md:tw-w-1/2  tw-mb-6 tw-px-2">
              <label
                class="tw-block tw-text-left tw-text-gray-700 tw-text-sm tw-font-bold tw-mb-2"
                for="firstName"
                >First Name</label
              >
              <input
                class="tw-shadow tw-appearance-none tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-mb-3 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                id="firstName"
                type="text"
                placeholder="e.g Jane"
                v-model="data.firstName"
              />
              <p v-if="errors.firstName" class="tw-text-xs tw-text-red-500">
                Please enter your first Name.
              </p>
            </div>
            <div class="tw-w-full md:tw-w-1/2  tw-mb-6 tw-px-2">
              <label
                class="tw-block tw-text-left tw-text-gray-700 tw-text-sm tw-font-bold tw-mb-2"
                for="lastName"
                >Last Name</label
              >
              <input
                class="tw-shadow tw-appearance-none tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-mb-3 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                id="password"
                type="lastName"
                placeholder="e.g Doe"
                v-model="data.lastName"
              />
              <p v-if="errors.lastName" class="tw-text-xs tw-text-red-500">
                Please enter your last Name.
              </p>
            </div>
          </div>
          <div class="tw-flex tw-flex-wrap">
            <div class="tw-w-full md:tw-w-1/2 tw-mb-6 tw-px-2">
              <label
                class="tw-block tw-text-left tw-text-gray-700 tw-text-sm tw-font-bold tw-mb-2"
                for="email"
                >Email <Address></Address
              ></label>
              <input
                class="tw-shadow tw-appearance-none tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-mb-3 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                id="email"
                type="email"
                placeholder="e.g mail@ekocarbon.com"
                v-model="data.email"
              />
              <p v-if="errors.email" class="tw-text-xs tw-text-red-500">
                Please enter your email address.
              </p>
            </div>
            <div class="tw-w-full md:tw-w-1/2 tw-mb-6 tw-px-2">
              <label
                class="tw-block tw-text-left tw-text-gray-700 tw-text-sm tw-font-bold tw-mb-2"
                for="phoneNumber"
                >Phone Number</label
              >
              <input
                class="tw-shadow tw-appearance-none tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-mb-3 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                id="phoneNumber"
                type="number"
                placeholder="e.g 08103374289"
                v-model="data.phoneNumber"
              />
              <p v-if="errors.phoneNumber" class="tw-text-xs tw-text-red-500">
                Please enter your phone Number.
              </p>
            </div>
          </div>
          <div class="tw-flex tw-flex-wrap">
            <div class="tw-w-full md:tw-w-1/2 tw-mb-6 tw-px-2">
              <label
                class="tw-block tw-text-left tw-text-gray-700 tw-text-sm tw-font-bold tw-mb-2"
                for="password"
                >Password</label
              >
              <input
                class="tw-shadow tw-appearance-none tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-mb-3 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                id="password"
                type="password"
                placeholder="******************"
                v-model="data.password"
              />
              <p v-if="errors.password" class="tw-text-xs tw-text-red-500">
                Please enter your password.
              </p>
            </div>

            <div class="tw-w-full md:tw-w-1/2 tw-mb-6 tw-px-2">
              <label
                class="tw-block tw-text-left tw-text-gray-700 tw-text-sm tw-font-bold tw-mb-2"
                for="password"
                >Confirm Password</label
              >
              <input
                class="tw-shadow tw-appearance-none tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-mb-3 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                id="password"
                type="password"
                placeholder="******************"
                v-model="conf_password"
              />
              <p v-if="errors.conf_password" class="tw-text-xs tw-text-red-500">
                Passwords don't match.
              </p>
            </div>
          </div>
          <vue-element-loading
            v-if="loading"
            :active="loading"
            :is-full-screen="true"
          />
          <button
            @click.prevent="submit"
            class="tw-bg-eko-dark hover:tw-bg-idea-dark tw-w-full tw-mb-6 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded focus:tw-outline-none focus:tw-shadow-outline"
            type="button"
          >
            Create Admin
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      loading: false,
      error: false,
      errors: {},
      error_msg: "",
      FB: null,
      conf_password: "",
    };
  },
  mounted() {
    this.token = localStorage.getItem("idea-token");
    this.user = JSON.parse(localStorage.getItem("idea-user"));
    this.admin = JSON.parse(localStorage.getItem("idea-admin"));
  },
  methods: {
    submit() {
      this.error_msg = "";
      this.loading = false;
      this.errors = {};
      let deny = false;
      if (!this.data.firstName) {
        this.errors.firstName = true;
        deny = true;
      }
      if (!this.data.lastName) {
        this.errors.lastName = true;
        deny = true;
      }
      if (!this.data.email) {
        this.errors.email = true;
        deny = true;
      }
      if (!this.data.phoneNumber) {
        this.errors.phoneNumber = true;
        deny = true;
      }
      if (!this.data.password) {
        this.errors.password = true;
        deny = true;
      }
      if (this.data.password !== this.conf_password) {
        this.errors.conf_password = true;
        deny = true;
      }
      if (deny) {
        return;
      }
      const self = this;
      self.loading = true;
      this.data.userType = "admin";
      axios
        .post(`${this.$baseUrl}/user/create`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          self.loading = false;
          self.success = true;
          this.$swal("Success!", "Admin created successfully!", "success");
          localStorage.setItem("eko-carbon-token", response.data.token);
          localStorage.setItem(
            "eko-carbon-user",
            JSON.stringify(response.data.user)
          );
          this.data = {};
        })
        .catch((error) => {
          self.loading = false;
          self.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
